interface SpeechBubbleProps {
  message: string;
}

export function SpeechBubble({ message }: SpeechBubbleProps) {
  return (
    <div className="absolute -top-4 left-full ml-4 animate-fold">
      <div className="bg-white rounded-lg shadow-lg p-3 max-w-xs relative">
        {/* Tail pointing to crane */}
        <div className="absolute left-0 top-1/2 -translate-x-2 -translate-y-1/2">
          <div className="w-0 h-0 border-t-8 border-b-8 border-r-8 border-transparent border-r-white" />
        </div>
        <p className="text-sm text-text-dark">{message}</p>
      </div>
    </div>
  );
}
